import React from 'react';
import Link from "./Link.tsx";

interface LinksProps {
    offset: number;
    iterObject: any[];
    editedContent: any;
    setEditedContent: any;
    isEditing: boolean;
    role: string | null;
}

const Links: React.FC<LinksProps> = (
    {
        offset,
        iterObject,
        editedContent = null,
        setEditedContent = null,
        isEditing,
        role
    }) => {
    const handleRemoveFile = (index: number) => {
        const updatedContent = [...editedContent];
        updatedContent.splice(index, 1);
        setEditedContent(updatedContent);
    };

    return (
        <>
            {iterObject.length > 0 && (
                <div className={`bg-neutral-100 dark:bg-neutral-900 my-3 rounded-2xl border border-neutral-800 overflow-hidden`}>
                    <div className="flex overflow-x-auto">
                        {iterObject.map((item: any, index: number) => {
                            const fileIndex = offset + index;
                            return (
                                <div key={fileIndex} className="flex-none relative mx-auto">
                                    <Link item={item} index={index} role={role} />
                                    {isEditing && (
                                        <button
                                            className="absolute top-1.5 right-0.5 bg-red-800 text-white border-none rounded-full w-5 h-5 text-xs flex justify-center items-center cursor-pointer"
                                            onClick={() => handleRemoveFile(fileIndex)}
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default Links;
